<template>
    <sidebar-menu :items="items" has-icon @update:expanded="$emit('update:expanded', $event)" />
</template>

<script>
import get from 'lodash/get.js';
import SidebarMenu from '@/components/sidebar/SidebarMenu.vue';
import Page from '@/models/pages/Page.js';
import PageFolder from '@/models/pages/PageFolder.js';

export default {
    name: 'EditPagesSidebar',

    components: { SidebarMenu },

    emits: ['update:expanded'],

    computed: {
        pageLength() {
            return Page.query().count();
        },

        pageFolderLength() {
            return PageFolder.query().count();
        },

        items() {
            return get(this.$store.state, 'sidebarItems');
        },
    },

    watch: {
        $route(to, from) {
            const routes = [
                'edit-page-edit',
                'page-folder-edit',
                'edit-page-create',
                'edit-page-create-root',
                'page-folder-create',
                'page-folder-create-root',
            ];

            if (routes.includes(from.name)) {
                Page.fetchEditPageMenu(this.$store);
            }
        },

        pageLength() {
            Page.fetchEditPageMenu(this.$store);
        },

        pageFolderLength() {
            Page.fetchEditPageMenu(this.$store);
        },
    },
};
</script>
